import { Component, OnInit } from '@angular/core';
import { ModalPausePlanComponent } from '../modal-pause-plan/modal-pause-plan.component';
import { MatDialog } from '@angular/material';
import { ModalCancelPlanComponent } from '../modal-cancel-plan/modal-cancel-plan.component';

@Component({
  selector: 'app-modal-select-cancel-pause-plan',
  templateUrl: './modal-select-cancel-pause-plan.component.html',
  styleUrls: ['./modal-select-cancel-pause-plan.component.scss']
})
export class ModalSelectCancelPausePlanComponent implements OnInit {

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit() {
  }


  openPauseSubscriptionModal() {
    this.dialog
    .open(ModalPausePlanComponent, {
      width: '470px',
      height: 'auto',
      autoFocus: false,
      data: {
      }
    })
    .afterClosed();
  }


  openCancelSubscriptionModal() {
    this.dialog
    .open(ModalCancelPlanComponent, {
      width: '410px',
      height: 'auto',
      autoFocus: false,
      panelClass: 'remove-padding',
      data: {
      }
    })
    .afterClosed();
  }

}
